const factory = ({ blockchainMetadata }) => {
    const onStart = async () => {
        await blockchainMetadata.clear();
    };
    return { onStart };
};
const publicKeyProviderDebugPluginDefinition = {
    id: 'publicKeyProviderDebugPlugin',
    type: 'plugin',
    factory,
    dependencies: ['blockchainMetadata'],
    public: true,
};
export default publicKeyProviderDebugPluginDefinition;
